<template>
    <div class="row-actions text-nowrap">
        <b-button v-for="action in visibleActions"
                  :key="action.key || action.icon"
                  v-b-tooltip.hover.top="action.title"
                  :variant="'flat-' + (action.variant || 'secondary')"
                  :to="action.to"
                  :href="action.href"
                  :target="action.target"
                  :disabled="action.disabled"
                  :aria-label="action.title"
                  class="btn-icon rounded-circle row-actions__btn"
                  @click="trigger(action, $event)">
            <feather-icon :icon="action.icon" :size="String(iconSize)"></feather-icon>
        </b-button>
    </div>
</template>

<script>
    /*
     * Icon-only actions for table rows / list items with proper touch targets.
     *
     *   actions: [{ key?, icon, title, to?, href?, click?, variant?, disabled?, visible? }]
     */
    export default {
        props: {
            actions: {
                type: Array,
                default: () => []
            },
            iconSize: {
                type: [Number, String],
                default: 16
            }
        },
        computed: {
            visibleActions() {
                return this.actions.filter(x => x && x.visible !== false)
            }
        },
        methods: {
            trigger(action, e) {
                if (action.click) {
                    e.stopPropagation()
                    action.click()
                }
                this.$emit('action', action.key || action.icon)
            }
        }
    }
</script>

<style lang="scss" scoped>
    .row-actions {
        display: inline-flex;
        align-items: center;
        gap: 2px;
        margin: -6px 0;
    }

    .row-actions__btn {
        width: 40px;
        height: 40px;
        padding: 0 !important;
        display: inline-flex;
        align-items: center;
        justify-content: center;
    }
</style>
